<div class="agent-settings-view" onsip-grid-placement-shelf>
  <div class="first-column">
    <section class="property">
      <div class="mat-body-1 property-header">Ring Strategy</div>
      <div>{{ ringStrategyMap[queue.ringStrategy] }}</div>
    </section>
    <section class="property">
      <div class="mat-body-1 property-header">Ring duration</div>
      <div>{{ queue.agentTimeout + " seconds" }}</div>
    </section>
    <section class="property">
      <div class="mat-body-1 property-header">Connection delay</div>
      <div>{{ queue.memberDelay + " seconds" }}</div>
    </section>
    <section class="property">
      <div class="mat-body-1 property-header">Announce caller hold time to agent</div>
      <div>{{ queue.reportHoldTime ? "Yes" : "No" }}</div>
    </section>
    <section class="property">
      <div class="mat-body-1 property-header">Post call wrap up</div>
      <div>{{ queue.wrapupTime + " seconds" }}</div>
    </section>
  </div>
</div>
<div class="page-view-controls">
  <button mat-flat-button class="toggle-button" color="primary" (click)="togglePanel()">
    {{ "ONSIP_I18N.EDIT_INFO" | translate }}
  </button>
</div>
